import React from 'react';
import PropTypes from 'prop-types';
import Usp from '../ui_usp/component';

const DeliveryPromise = ({ offered, icon = 'default', showIcon, ...rest }) => {
  let iconType = icon;
  if (offered === 0) {
    iconType = 'error';
  } else if (offered === 2 || offered === 4) {
    iconType = 'info';
  }

  return (
    <Usp icon={showIcon ? iconType : 'no-icon'} {...rest}/>
  );
};

DeliveryPromise.propTypes = {
  offered: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  text: PropTypes.string,
  textKey: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
  showIcon: PropTypes.bool,
};

export default DeliveryPromise;
